import React from 'react';
import { Helmet } from "react-helmet";

//CORE COMPOENTNS
import { ThemeProvider, styled } from '../../../components-core/packages/components-core/dist/theme-provider';
import scroll from '../lead-section/LeadSection'
//LAYOUT
import {
    Container,
    ContainerGutter,
    ContainerWrap,
    ContainerPadding,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';

//STYLE
import { Text, TextAppearance, TextAlignment, TextColor } from '../../../components-core/packages/components-core/dist/text';
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button'
import LayoutTwo from '../../components/layouttwo'
import { Link } from '../../../components-core/packages/components-core/dist/link/index';


import { Layout, LayoutConfigurations } from '../../../components-core/packages/components-core/dist/layout/index';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';

const TopView = styled.div`
    width: 100vw;
    
`;

const CustomContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Line = styled.div`
    background-color: #dfe4e8;
    width: 100%;
    height: 2px;
`;

const grid001 = ContainerPadding.grid001;
const grid002 = ContainerPadding.grid002;
const grid003 = ContainerPadding.grid003;
const grid004 = ContainerPadding.grid004;

const generalPadding = {
    [Breakpoints.default]: grid002,
    [Breakpoints.b960]: grid003,
    [Breakpoints.b1280]: grid004,
}

const singleColumnPadding = {
    [Breakpoints.default]: grid001,
    [Breakpoints.b560]: grid001,
}

class UserServiceList extends React.Component {

    constructor() {
        super();
        this.state = {
        }
    }

    renderLeftContainer() {
        
        const paddings = {
            left: {
                [Breakpoints.default]: grid002,
                [Breakpoints.b960]: grid002,
                [Breakpoints.b1280]: grid004
            },
            right: {
                [Breakpoints.default]: grid002,
                [Breakpoints.b960]: grid002,
                [Breakpoints.b1280]: grid001
            },
        }

        const alignments = {
            [Breakpoints.default]: ContainerHorizontalAlignment.center,
            [Breakpoints.b960]: ContainerHorizontalAlignment.flexStart,
            [Breakpoints.b1280]: ContainerHorizontalAlignment.center,
        }

        const textAlignments = {
            [Breakpoints.default]: TextAlignment.center,
            [Breakpoints.b960]: TextAlignment.left,
            [Breakpoints.b1280]: TextAlignment.center,
        }

        const TopTextDealerService = (
            <Container>
                <Text 
                    appearance={TextAppearance.headline0250} 
                    
                >
                    En son ziyaret edilen <br /><b>yetkili servis</b>
                </Text> 
 
            </Container>
        )


            

        return(
            <CustomContainer>
                <Container                 
                    gutter={ContainerGutter.dynamic0100}
                    horizontalAlign={alignments}
                    padding={paddings} 

                >
                    {TopTextDealerService}
                    <Line/>
                    <Container 
                        wrap={ContainerWrap.always} 
                        horizontalAlign={alignments}
                        gutter={ContainerGutter.dynamic0100}
                    >
                        <Container>
                        <Text color={TextColor.secondary}>Yetkili servis<br/>Şerifhan Işıklı</Text>
                        </Container>
                        <Container>
                        <Text color={TextColor.secondary}>Servis Danışmanı<br/>Şerifhan Işıklı</Text>
                        
                        </Container>
                        <Container >
                        <Text color={TextColor.secondary}>Servis Telefonu<br/>+90 537 040 3797</Text>
                        
                        </Container>
                    </Container>
                </Container>
            </CustomContainer>
        )
    }

    renderRightContainer() {
        
        const paddings = {
            left: {
                [Breakpoints.default]: grid001,
                [Breakpoints.b960]: grid001,
                [Breakpoints.b1280]: grid002
            },
            right: {
                [Breakpoints.default]: grid002,
                [Breakpoints.b960]: grid002,
                [Breakpoints.b1280]: grid001
            },
        }

        const alignments = {
            [Breakpoints.default]: ContainerHorizontalAlignment.center,
            [Breakpoints.b960]: ContainerHorizontalAlignment.flexStart,
            [Breakpoints.b1280]: ContainerHorizontalAlignment.center,
        }

        const textAlignments = {
            [Breakpoints.default]: TextAlignment.center,
            [Breakpoints.b960]: TextAlignment.left,
            [Breakpoints.b1280]: TextAlignment.center,
        }

        const TopTextDealerSealer = (
            <Container>
                <Text 
                    appearance={TextAppearance.headline0250} 
                    
                >
                    En son ziyaret edilen <br /><b>yetkili satıcı</b>
                </Text> 
 
            </Container>
        )


            

        return(
            <CustomContainer>
                <Container                 
                    gutter={ContainerGutter.dynamic0100}
                    padding={paddings} 
                    horizontalAlign={alignments}
                >
                    {TopTextDealerSealer}
                    <Line/>
                    <Container 
                        wrap={ContainerWrap.always} 
                        horizontalAlign={alignments}
                        gutter={ContainerGutter.dynamic0100}
                    >
                        <Container>
                        <Text color={TextColor.secondary}>Yetkili satıcı<br/> <Text>Şerifhan Işıklı</Text></Text>
                        </Container>
                        <Container>
                        <Text color={TextColor.secondary}>Satış Danışmanı<br/><Text>Şerifhan Işıklı</Text></Text>
                        </Container>
                       
                    </Container>
                </Container>
            </CustomContainer>
        )
    }


    render() {
        return(
            <ThemeProvider>
            <TopView>
                <Container padding={{ top: ContainerPadding.dynamic0250, bottom: ContainerPadding.dynamic0250 }}>
                    <Layout appearance={LayoutConfigurations.half} rowGap={ContainerGutter.dynamic0250} >
                        {this.renderLeftContainer()}
                        {this.renderRightContainer()}
                    </Layout>
                </Container>
            </TopView>
        </ThemeProvider>
        )
    }
}

export default UserServiceList;